import { fetchUserAttributes, signOut } from 'aws-amplify/auth';

import { UserAttributes } from '../interfaces';

export abstract class AuthService {
  public static getUserAttributes = async (): Promise<UserAttributes | null> => {
    try {
      const userAttributes = await fetchUserAttributes().catch((err) => {
        console.error(err);
        signOut();
        localStorage.setItem('userLogged', 'false');
        window.location.href = '/';
      });
      return userAttributes;
    } catch (error) {
      console.warn(error);
      return null;
    }
  };

  public static getUserFleetId = async (): Promise<string | null> => {
    try {
      const userAttributes = await this.getUserAttributes();
      const fleetId = userAttributes?.['custom:fleet_id'] ?? '';
      return fleetId;
    } catch (error) {
      console.warn(error);
      return null;
    }
  };
}
